var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { TMS_THEME } from "../theming/theming";
import { useStylesHook } from "./useStylesHook";
/** Be consistent Tailwinds naming structure where possible - https://tailwindcss.com/docs
 * For ease of understanding don't use the single letter example from Tailwind and replace
 * with a name, eg pr is rightPadding
 *
 * Any padding or margin added to the Styles option should be based of the BASE_SIZE of 4px.
 * We default the Margin / Space and Padding to 12px.
 */
export var UtilityStyle;
(function (UtilityStyle) {
    UtilityStyle["Relative"] = "relative";
    UtilityStyle["Absolute"] = "absolute";
    UtilityStyle["Block"] = "block";
    UtilityStyle["Flex"] = "flex";
    UtilityStyle["InlineBlock"] = "inlineBlock";
    UtilityStyle["ItemsCenter"] = "itemsCenter";
    UtilityStyle["AlignMiddle"] = "alignMiddle";
    UtilityStyle["JustifyBetween"] = "justifyBetween";
    UtilityStyle["SelfBaseline"] = "selfBaseline";
    UtilityStyle["Shrink"] = "shrink";
    UtilityStyle["ShrinkZero"] = "shrinkZero";
    UtilityStyle["SelfCenter"] = "selfCenter";
    UtilityStyle["FloatRight"] = "floatRight";
    UtilityStyle["Clear"] = "clear";
    UtilityStyle["HorizontalPaddingZero"] = "horizontalPaddingZero";
    UtilityStyle["HorizontalPaddingSmall"] = "horizontalPaddingSmall";
    UtilityStyle["HorizontalPaddingMedium"] = "horizontalPaddingMedium";
    UtilityStyle["HorizontalPadding"] = "horizontalPadding";
    UtilityStyle["HorizontalPaddingLarge"] = "horizontalPaddingLarge";
    UtilityStyle["VerticalPaddingZero"] = "verticalPaddingZero";
    UtilityStyle["VerticalPaddingSmall"] = "verticalPaddingSmall";
    UtilityStyle["VerticalPaddingMedium"] = "verticalPaddingMedium";
    UtilityStyle["VerticalPadding"] = "verticalPadding";
    UtilityStyle["VerticalPaddingLarge"] = "verticalPaddingLarge";
    UtilityStyle["FlexOne"] = "flexOne";
    UtilityStyle["RightSpaceLarge"] = "rightSpaceLarge";
    UtilityStyle["LeftSpaceLarge"] = "leftSpaceLarge";
    UtilityStyle["BottomSpaceLarge"] = "bottomSpaceLarge";
    UtilityStyle["TopSpaceLarge"] = "topSpaceLarge";
    UtilityStyle["RightSpace"] = "rightSpace";
    UtilityStyle["LeftSpace"] = "leftSpace";
    UtilityStyle["BottomSpace"] = "bottomSpace";
    UtilityStyle["TopSpace"] = "topSpace";
    UtilityStyle["RightSpaceMedium"] = "rightSpaceMedium";
    UtilityStyle["LeftSpaceMedium"] = "leftSpaceMedium";
    UtilityStyle["BottomSpaceMedium"] = "bottomSpaceMedium";
    UtilityStyle["TopSpaceMedium"] = "topSpaceMedium";
    UtilityStyle["RightSpaceSmall"] = "rightSpaceSmall";
    UtilityStyle["LeftSpaceSmall"] = "leftSpaceSmall";
    UtilityStyle["BottomSpaceSmall"] = "bottomSpaceSmall";
    UtilityStyle["TopSpaceSmall"] = "topSpaceSmall";
    UtilityStyle["RightSpaceZero"] = "rightSpaceZero";
    UtilityStyle["LeftSpaceZero"] = "leftSpaceZero";
    UtilityStyle["BottomSpaceZero"] = "bottomSpaceZero";
    UtilityStyle["TopSpaceZero"] = "topSpaceZero";
    UtilityStyle["RightSpaceAuto"] = "rightSpaceAuto";
    UtilityStyle["LeftSpaceAuto"] = "leftSpaceAuto";
    UtilityStyle["BottomSpaceAuto"] = "bottomSpaceAuto";
    UtilityStyle["TopSpaceAuto"] = "topSpaceAuto";
    UtilityStyle["HeaderFont"] = "headerFont";
    UtilityStyle["TextCenter"] = "textCenter";
    UtilityStyle["Truncate"] = "truncate";
    UtilityStyle["FontLight"] = "fontLight";
    UtilityStyle["FontNormal"] = "fontNormal";
    UtilityStyle["FontBold"] = "fontBold";
    UtilityStyle["TextLarge"] = "textLarge";
    UtilityStyle["TextBlack"] = "textBlack";
    UtilityStyle["TextSlate"] = "textSlate";
    UtilityStyle["TextCharcoal"] = "textCharcoal";
    UtilityStyle["TextSilver"] = "textSilver";
    UtilityStyle["TextSmoke"] = "textSmoke";
    UtilityStyle["TextCloud"] = "textCloud";
    UtilityStyle["TextFog"] = "textFog";
    UtilityStyle["TextMist"] = "textMist";
    UtilityStyle["TextWhite"] = "textWhite";
    UtilityStyle["BackgroundBlack"] = "backgroundBlack";
    UtilityStyle["BackgroundSlate"] = "backgroundSlate";
    UtilityStyle["BackgroundCharcoal"] = "backgroundCharcoal";
    UtilityStyle["BackgroundSilver"] = "backgroundSilver";
    UtilityStyle["BackgroundSmoke"] = "backgroundSmoke";
    UtilityStyle["BackgroundCloud"] = "backgroundCloud";
    UtilityStyle["BackgroundFog"] = "backgroundFog";
    UtilityStyle["BackgroundMist"] = "backgroundMist";
    UtilityStyle["BackgroundWhite"] = "backgroundWhite";
    UtilityStyle["Border"] = "border";
    UtilityStyle["BottomBorderZero"] = "bottomBorderZero";
    UtilityStyle["TopBorderZero"] = "topBorderZero";
    UtilityStyle["RightBorderZero"] = "rightBorderZero";
    UtilityStyle["LeftBorderZero"] = "leftBorderZero";
})(UtilityStyle || (UtilityStyle = {}));
export var useUtilityStyles = function (config) {
    var utilities = {};
    var multipleUtilities = {};
    config === null || config === void 0 ? void 0 : config.forEach(function (option) {
        if (typeof option !== "object") {
            utilities = __assign(__assign({}, utilities), STYLES_MAP[option]);
        }
        else {
            multipleUtilities = __assign(__assign({}, multipleUtilities), option);
        }
    });
    var utilitiesWithStyles = {};
    Object.keys(multipleUtilities).forEach(function (className) {
        var _a;
        var utilities = {};
        if (className === "utilities") {
            throw new Error("[piston-ux] utilities is a protected class name");
        }
        multipleUtilities[className].forEach(function (option) {
            utilities = __assign(__assign({}, utilities), STYLES_MAP[option]);
        });
        utilitiesWithStyles = __assign(__assign({}, utilitiesWithStyles), (_a = {}, _a[className] = utilities, _a));
    });
    return useStylesHook(__assign({ utilities: utilities }, utilitiesWithStyles));
};
export var hasUtilityStyle = function (componentStyles, toFind) { return !!(componentStyles === null || componentStyles === void 0 ? void 0 : componentStyles.find(function (style) { return style === toFind; })); };
export var BASE_SIZE = 4;
export var SMALL_SIZE = BASE_SIZE;
export var MEDIUM_SIZE = BASE_SIZE * 2;
export var DEFAULT_SIZE = BASE_SIZE * 3;
export var LARGE_SIZE = BASE_SIZE * 4;
var cssPixelValue = function (value) { return "".concat(value, "px !important"); };
export var STYLES_MAP = (_a = {},
    _a[UtilityStyle.Relative] = { position: "relative !important" },
    _a[UtilityStyle.Absolute] = { position: "absolute !important" },
    _a[UtilityStyle.Block] = { display: "block !important" },
    _a[UtilityStyle.InlineBlock] = { display: "inline-block !important" },
    _a[UtilityStyle.Flex] = { display: "flex !important" },
    _a[UtilityStyle.ItemsCenter] = { alignItems: "center !important" },
    _a[UtilityStyle.JustifyBetween] = { justifyContent: "space-between !important" },
    _a[UtilityStyle.SelfBaseline] = { alignSelf: "baseline !important" },
    _a[UtilityStyle.SelfCenter] = { alignSelf: "center !important" },
    _a[UtilityStyle.Shrink] = { flexShrink: "1 !important" },
    _a[UtilityStyle.ShrinkZero] = { flexShrink: "0 !important" },
    _a[UtilityStyle.TextCenter] = { textAlign: "center !important" },
    _a[UtilityStyle.FloatRight] = { float: "right !important" },
    _a[UtilityStyle.Clear] = { clear: "both !important" },
    _a[UtilityStyle.AlignMiddle] = { verticalAlign: "middle !important" },
    _a[UtilityStyle.HeaderFont] = {
        fontFamily: "var(--font-family-header) !important",
    },
    _a[UtilityStyle.FontLight] = { fontWeight: "300 !important" },
    _a[UtilityStyle.FontNormal] = { fontWeight: "400 !important" },
    _a[UtilityStyle.FontBold] = { fontWeight: "500 !important" },
    _a[UtilityStyle.TextBlack] = {
        color: "".concat(TMS_THEME.palette.gray.black.color, " !important"),
    },
    _a[UtilityStyle.TextSlate] = {
        color: "".concat(TMS_THEME.palette.gray.slate.color, " !important"),
    },
    _a[UtilityStyle.TextCharcoal] = {
        color: "".concat(TMS_THEME.palette.gray.charcoal.color, " !important"),
    },
    _a[UtilityStyle.TextSilver] = {
        color: "".concat(TMS_THEME.palette.gray.silver.color, " !important"),
    },
    _a[UtilityStyle.TextSmoke] = {
        color: "".concat(TMS_THEME.palette.gray.smoke.color, " !important"),
    },
    _a[UtilityStyle.TextCloud] = {
        color: "".concat(TMS_THEME.palette.gray.cloud.color, " !important"),
    },
    _a[UtilityStyle.TextFog] = {
        color: "".concat(TMS_THEME.palette.gray.fog.color, " !important"),
    },
    _a[UtilityStyle.TextMist] = {
        color: "".concat(TMS_THEME.palette.gray.mist.color, " !important"),
    },
    _a[UtilityStyle.TextWhite] = {
        color: "".concat(TMS_THEME.palette.gray.white.color, " !important"),
    },
    _a[UtilityStyle.BackgroundBlack] = {
        backgroundColor: "".concat(TMS_THEME.palette.gray.black.color, " !important"),
    },
    _a[UtilityStyle.BackgroundSlate] = {
        backgroundColor: "".concat(TMS_THEME.palette.gray.slate.color, " !important"),
    },
    _a[UtilityStyle.BackgroundCharcoal] = {
        backgroundColor: "".concat(TMS_THEME.palette.gray.charcoal.color, " !important"),
    },
    _a[UtilityStyle.BackgroundSilver] = {
        backgroundColor: "".concat(TMS_THEME.palette.gray.silver.color, " !important"),
    },
    _a[UtilityStyle.BackgroundSmoke] = {
        backgroundColor: "".concat(TMS_THEME.palette.gray.smoke.color, " !important"),
    },
    _a[UtilityStyle.BackgroundCloud] = {
        backgroundColor: "".concat(TMS_THEME.palette.gray.cloud.color, " !important"),
    },
    _a[UtilityStyle.BackgroundFog] = {
        backgroundColor: "".concat(TMS_THEME.palette.gray.fog.color, " !important"),
    },
    _a[UtilityStyle.BackgroundMist] = {
        backgroundColor: "".concat(TMS_THEME.palette.gray.mist.color, " !important"),
    },
    _a[UtilityStyle.BackgroundWhite] = {
        backgroundColor: "".concat(TMS_THEME.palette.gray.white.color, " !important"),
    },
    _a[UtilityStyle.TextLarge] = {
        fontSize: cssPixelValue(TMS_THEME.typography.h3.fontSize),
    },
    _a[UtilityStyle.Truncate] = {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    _a[UtilityStyle.Border] = {
        border: "1px solid ".concat(TMS_THEME.palette.gray.smoke.color, " !important"),
    },
    _a[UtilityStyle.BottomBorderZero] = { borderBottom: "0px !important" },
    _a[UtilityStyle.TopBorderZero] = { borderTop: "0px !important" },
    _a[UtilityStyle.RightBorderZero] = { borderRight: "0px !important" },
    _a[UtilityStyle.LeftBorderZero] = { borderLeft: "0px !important" },
    _a[UtilityStyle.HorizontalPaddingZero] = {
        paddingLeft: cssPixelValue(0),
        paddingRight: cssPixelValue(0),
    },
    _a[UtilityStyle.HorizontalPaddingSmall] = {
        paddingLeft: cssPixelValue(SMALL_SIZE),
        paddingRight: cssPixelValue(SMALL_SIZE),
    },
    _a[UtilityStyle.HorizontalPaddingMedium] = {
        paddingLeft: cssPixelValue(MEDIUM_SIZE),
        paddingRight: cssPixelValue(MEDIUM_SIZE),
    },
    _a[UtilityStyle.HorizontalPadding] = {
        paddingLeft: cssPixelValue(DEFAULT_SIZE),
        paddingRight: cssPixelValue(DEFAULT_SIZE),
    },
    _a[UtilityStyle.HorizontalPaddingLarge] = {
        paddingLeft: cssPixelValue(LARGE_SIZE),
        paddingRight: cssPixelValue(LARGE_SIZE),
    },
    _a[UtilityStyle.VerticalPaddingZero] = {
        paddingTop: cssPixelValue(0),
        paddingBottom: cssPixelValue(0),
    },
    _a[UtilityStyle.VerticalPaddingSmall] = {
        paddingTop: cssPixelValue(SMALL_SIZE),
        paddingBottom: cssPixelValue(SMALL_SIZE),
    },
    _a[UtilityStyle.VerticalPaddingMedium] = {
        paddingTop: cssPixelValue(MEDIUM_SIZE),
        paddingBottom: cssPixelValue(MEDIUM_SIZE),
    },
    _a[UtilityStyle.VerticalPadding] = {
        paddingTop: cssPixelValue(DEFAULT_SIZE),
        paddingBottom: cssPixelValue(DEFAULT_SIZE),
    },
    _a[UtilityStyle.VerticalPaddingLarge] = {
        paddingTop: cssPixelValue(LARGE_SIZE),
        paddingBottom: cssPixelValue(LARGE_SIZE),
    },
    _a[UtilityStyle.RightSpaceLarge] = { marginRight: cssPixelValue(LARGE_SIZE) },
    _a[UtilityStyle.LeftSpaceLarge] = { marginLeft: cssPixelValue(LARGE_SIZE) },
    _a[UtilityStyle.BottomSpaceLarge] = { marginBottom: cssPixelValue(LARGE_SIZE) },
    _a[UtilityStyle.TopSpaceLarge] = { marginTop: cssPixelValue(LARGE_SIZE) },
    _a[UtilityStyle.RightSpace] = { marginRight: cssPixelValue(DEFAULT_SIZE) },
    _a[UtilityStyle.LeftSpace] = { marginLeft: cssPixelValue(DEFAULT_SIZE) },
    _a[UtilityStyle.BottomSpace] = { marginBottom: cssPixelValue(DEFAULT_SIZE) },
    _a[UtilityStyle.TopSpace] = { marginTop: cssPixelValue(DEFAULT_SIZE) },
    _a[UtilityStyle.RightSpaceMedium] = { marginRight: cssPixelValue(MEDIUM_SIZE) },
    _a[UtilityStyle.LeftSpaceMedium] = { marginLeft: cssPixelValue(MEDIUM_SIZE) },
    _a[UtilityStyle.BottomSpaceMedium] = {
        marginBottom: cssPixelValue(MEDIUM_SIZE),
    },
    _a[UtilityStyle.TopSpaceMedium] = { marginTop: cssPixelValue(MEDIUM_SIZE) },
    _a[UtilityStyle.RightSpaceSmall] = { marginRight: cssPixelValue(SMALL_SIZE) },
    _a[UtilityStyle.LeftSpaceSmall] = { marginLeft: cssPixelValue(SMALL_SIZE) },
    _a[UtilityStyle.TopSpaceSmall] = { marginTop: cssPixelValue(SMALL_SIZE) },
    _a[UtilityStyle.BottomSpaceSmall] = {
        marginBottom: cssPixelValue(SMALL_SIZE),
    },
    _a[UtilityStyle.RightSpaceZero] = { marginRight: cssPixelValue(0) },
    _a[UtilityStyle.LeftSpaceZero] = { marginLeft: cssPixelValue(0) },
    _a[UtilityStyle.TopSpaceZero] = { marginTop: cssPixelValue(0) },
    _a[UtilityStyle.BottomSpaceZero] = { marginBottom: cssPixelValue(0) },
    _a[UtilityStyle.RightSpaceAuto] = { marginRight: "auto !important" },
    _a[UtilityStyle.LeftSpaceAuto] = { marginLeft: "auto !important" },
    _a[UtilityStyle.TopSpaceAuto] = { marginTop: "auto !important" },
    _a[UtilityStyle.BottomSpaceAuto] = { marginBottom: "auto !important" },
    _a[UtilityStyle.FlexOne] = { flex: "1" },
    _a);
